

































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { sortBy } from 'lodash'

// Api
import { mapData, WEBHOOK_API_MAPPING } from '@/api/Mapping'

// Helpers
import { Meta } from '@/helpers/decorators'

// Mixins
import Errors from '@/mixins/Errors'

// Models
import Webhook from '@/models/Webhook'

// Components
import Box from '@/components/common/Box.vue'

// Views
import WebhookLine from '@/views/company/webhooks/WebhookLine.vue'


@Component({
  components: {
    Box,
    WebhookLine
  }
})
export default class WebhookCompany extends Mixins(Errors) {
  webhooks: [] = null
  newWebhooks = []
  loading = false
  canSave = false

  @Getter('token') token

  addNewWebhook() {
    this.newWebhooks.push(new Webhook({
      id: null,
      firstFinished: false,
      init: false,
      url: null,
      secret: null,
      secondFinished: false,
      update: false,
      createdAt: null
    }))
  }

  parseWebhook(webhook) {
    const model = new Webhook(mapData(WEBHOOK_API_MAPPING, webhook, false, true))
    return model
  }

  async mounted() {
    await this.fetch()
  }

  async fetch() {
    try {
      this.loading = true
      const res = await this.$api.webhooks.fetchWebhooks(this.token)
      this.webhooks = res.data.map((item) => this.parseWebhook(item))
      this.webhooks = this.webhooks.sort((a, b) => {
        // @ts-ignore
        return (a.createdAt as any) - (b.createdAt as any)
      })
    } finally {
      this.loading = false
    }
  }

  save() {
    this.loading = true
    setTimeout(() => this.loading = false, 300)
  }

  updateSave(val) {
    this.loading = val
  }

  userCanSave() {

    this.canSave = true
  }

  removeWebhook(index) {
    this.newWebhooks.splice(index, 1)
  }

  async reload() {
    this.newWebhooks = []
    await this.fetch()
  }
 }
